import CityPageTemplate from "../city-template/CityPageTemplate";
import { littletonConfig } from "./data";

export default function LittletonPage() {
  return <CityPageTemplate config={littletonConfig} />;
}